import { Connector } from '../../api/connector'

export interface Context {
  readonly connector: Connector
}

export type VulnerabilityStatus =
  | 'Reported'
  | 'Suspicious'
  | 'Confirmed'
  | 'NotAProblem'
  | 'Remediated'
  | 'Fixed'
  | 'AutoRemediated'

export const VulnerabilityStatusRegistry: {
  [key: string]: VulnerabilityStatus
} = {
  REPORTED: 'Reported',
  SUSPICIOUS: 'Suspicious',
  CONFIRMED: 'Confirmed',
  NOT_A_PROBLEM: 'NotAProblem',
  REMEDIATED: 'Remediated',
  FIXED: 'Fixed',
  AUTOREMEDIATED: 'AutoRemediated'
}

// Vulnerability Statuses
export const REPORTED = 'reported'
export const SUSPICIOUS = 'suspicious'
export const CONFIRMED = 'confirmed'
export const NOT_A_PROBLEM = 'notAProblem'
export const REMEDIATED = 'remediated'
export const FIXED = 'fixed'
export const AUTO_REMEDIATED = 'autoRemediated'

export const VULNERABILITY_STATUSES = [
  REPORTED,
  SUSPICIOUS,
  CONFIRMED,
  NOT_A_PROBLEM,
  REMEDIATED,
  FIXED,
  AUTO_REMEDIATED
]

export const VULNERABILITY_OPEN_STATUSES = [REPORTED, SUSPICIOUS, CONFIRMED]

export const vulnerabilityStatusToKey: Record<VulnerabilityStatus, string> = {
  Reported: REPORTED,
  Suspicious: SUSPICIOUS,
  Confirmed: CONFIRMED,
  NotAProblem: NOT_A_PROBLEM,
  Remediated: REMEDIATED,
  Fixed: FIXED,
  AutoRemediated: AUTO_REMEDIATED
}

export type VulnerabilityStatusDescription =
  | 'Reported'
  | 'Suspicious'
  | 'Confirmed'
  | 'Not a Problem'
  | 'Remediated'
  | 'Fixed'
  | 'Remediated - Auto-Verified'

export const vulnerabilityStatusDescriptionToValue: Record<
  VulnerabilityStatusDescription,
  VulnerabilityStatus
> = {
  Reported: 'Reported',
  Suspicious: 'Suspicious',
  Confirmed: 'Confirmed',
  'Not a Problem': 'NotAProblem',
  Remediated: 'Remediated',
  Fixed: 'Fixed',
  'Remediated - Auto-Verified': 'AutoRemediated'
}

export const isVulnStatusDescription = (v: string) =>
  Object.values(vulnerabilityStatusDescriptionToValue).some(
    (desc) => desc === v
  )

export const VulnerabilitySeverityRegistry = {
  NOTE: 'NOTE',
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  CRITICAL: 'CRITICAL'
}
export type VulnerabilitySeverity =
  (typeof VulnerabilitySeverityRegistry)[keyof typeof VulnerabilitySeverityRegistry]

// Vulnerability Severities
export const CRITICAL = 'critical'
export const HIGH = 'high'
export const MEDIUM = 'medium'
export const LOW = 'low'
export const NOTE = 'note'

export const VULNERABILITY_SEVERITIES = [CRITICAL, HIGH, MEDIUM, LOW, NOTE]

export const vulnerabilitySeverityToKey: Record<VulnerabilitySeverity, string> =
  {
    NOTE,
    LOW,
    MEDIUM,
    HIGH,
    CRITICAL
  }
